export default __webpack_public_path__ + "static/media/left-quote.5d74aa15.svg";